import siteSetting from "./env";

export default {
  AUTH: "Basic ZGF0ZWRpc2g6ZGF0ZWRpc2hAMTIz",

  LOGIN: siteSetting.api.url + "admin/login",
  FORGOT: siteSetting.api.url + "admin/forgotPassword",
  RESET: siteSetting.api.url + "admin/resetPassword",
  GET_USER: siteSetting.api.url + "admin/getUserList",
  GET_ADMIN_INVITED_USERS: siteSetting.api.url + "admin/getInvitedUserList",
  INVITE_USER_BY_SMS: siteSetting.api.url + "newDish/invite-sms",
  GET_COMMUNITY_POSTS: siteSetting.api.url + "admin/community/posts",
  GET_REASONS: siteSetting.api.url + "reason/getReason",
  GET_ADDRESS: siteSetting.api.url + "address/getAllAddressForAdmin",
  GET_ADMIN_DETAIL: siteSetting.api.url + "admin/getAdminInfo",
  CHANGE_PASSWORD: siteSetting.api.url + "admin/changePassword",
  CHANGE_USER_PASSWORD: siteSetting.api.url + "admin/resetPasswordOfUser",
  EDIT_PROFILE: siteSetting.api.url + "admin/editProfile",
  EDIT_USER_PROFILE: siteSetting.api.url + "admin/changeUserDetails",
  CHANGE_USER_STATUS: siteSetting.api.url + "admin/blockUser",
  DELETE_USER: siteSetting.api.url + "admin/deleteUser",
  GET_USER_DETAIL: siteSetting.api.url + "admin/getUserDetailForAdmin",
  GET_USER_DISHES: siteSetting.api.url + "admin/getUserDishesForAdmin",

  GET_REPORTED_USERS: siteSetting.api.url + "admin/getReportedUsers",
  GET_REPORTED_DISHES: siteSetting.api.url + "admin/getReportedDishes",
  ACCEPT_REPORTED_DISH: siteSetting.api.url + "admin/acceptReportedDish",
  REJECT_REPORTED_DISH: siteSetting.api.url + "admin/rejectReportedDish",
  // PUBLISH_COMMUNITY_POST: siteSetting.api.url + "admin/publishCommunityPost",
  // UNPUBLISH_COMMUNITY_POST: siteSetting.api.url + "admin/unpublishCommunityPost",
  PUBLISH_COMMUNITY_POST: (postId) =>
    `${siteSetting.api.url}admin/community/post/${postId}/publish`,

  UNPUBLISH_COMMUNITY_POST: (postId) =>
    `${siteSetting.api.url}admin/community/post/${postId}/unpublish`,
  SEND_DELETE_ACCOUNT_OTP: siteSetting.api.url + "user/sendOtp",
  VERIFY_OTP: siteSetting.api.url + "user/verifyOtp",
  DELETE_ACCOUNT_WITH_OTP: siteSetting.api.url + "admin/deleteUser",

  // Trust Score tier configuration
  GET_TRUST_SCORE: siteSetting.api.url + "trust-score/get",
  SAVE_TRUST_SCORE: siteSetting.api.url + "trust-score/create",
  UPDATE_TRUST_SCORE: siteSetting.api.url + "trust-score/update",
};
